module.exports = __webpack_public_path__ + "static/wave-c943cfe41bb3bef275cddfdf67a5d04f.png";